import React from 'react'
import Announcements from './Announcements'

function Home() {
  return (
    <>
      <div className=" h-screen w-full lg:block flex phones">
        <div className="w-[1200px] h-[1200px] hidden sm:block box-content fixed top-[500px] left-[-400px] z-[-1] rounded-full bg-darkblue "></div>
        <div className="w-[1200px] h-[1200px] hidden sm:block box-content fixed top-[400px] left-[800px]  z-[-2] rounded-full bg-blue "></div>
        <div className="w-fit lg:relative lg:m-0 md:p-0 left-32 top-24 m-auto">
          <p className="mb-1 text-xl text-blue">
            <a href="https://play.google.com/store/apps/details?id=co.autojoomer.autojoomer">
              <font>AutoJoomer on Play Store!</font>
            </a>{" "}
            |{" "}
            <a href="https://t.ly/FIBJ">
              <font color="green">AutoJoomer on Webstore</font>
            </a>{" "}
            |{" "}
            <a href="https://github.com/vishal-lokare/AutoJoomer/">
              GitHub Repo link
            </a>
          </p>
          <h1 className="md:text-[125px] text-[10vw] font-bold animate-title">
            AutoJoomer
          </h1>
          <p className="md:text-4xl text-xl animate-sub">
            College life, simplified.
          </p>

          {/* <Announcements/> */}
        </div>
      </div>
    </>
  );
}

export default Home